import { Delete, Edit } from '@mui/icons-material'
import {
  Button,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  styled,
} from '@mui/material'
import { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'
import { IProcurementPlanItem } from 'types/procurementPlans/procurementPlanItems'
import { IFile } from 'types/file'

interface IProcurementPlanItemOmitted extends Omit<IProcurementPlanItem, 'tender'> {}

interface Props {
  plans: IProcurementPlanItemOmitted[]
  onEdit?: (plan: IProcurementPlanItem) => void
  onAddFile?: (plan: IProcurementPlanItem, file: IFile) => void
  onDelete?: (planId: string) => void
  canEdit?: boolean
}

const StyledTable = styled(Table)(() => ({
  borderCollapse: 'collapse',
  width: '100%',
  '& th, & td': {
    border: '1px solid #dddddd !important',
  },
  '& th': {
    fontWeight: '600',
    whiteSpace: 'nowrap',
  },
  '& .MuiTableCell-root': {
    paddingLeft: '12px',
    paddingRight: '12px',
  },
}))

export const ProcurementPlansTable: FunctionComponent<Props> = ({
  plans,
  onEdit,
  onDelete,
  onAddFile,
  canEdit = true,
}) => {
  const { t } = useTranslation()

  return (
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
      <TableContainer>
        <StyledTable size="small" sx={{ minWidth: 650, borderCollapse: 'collapse' }}>
          <TableHead>
            <TableRow>
              <TableCell>{t('predmet-row-num')}</TableCell>
              <TableCell>{t('predmet-name')}</TableCell>
              <TableCell>{t('procurementMethod')}</TableCell>
              <TableCell>{t('anouncement-month')}</TableCell>
              <TableCell>{t('execution-address')}</TableCell>
              <TableCell>{t('execution-duration-in-days')}</TableCell>
              <TableCell>{t('proceed-to-competition')}</TableCell>
              {canEdit && <TableCell />}
            </TableRow>
          </TableHead>
          <TableBody>
            {plans.map((plan) => (
              <TableRow
                key={plan.id}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell scope="row">{plan.rowNum}</TableCell>
                <TableCell scope="row">{plan.name}</TableCell>
                <TableCell scope="row">{t(plan.method)}</TableCell>
                <TableCell scope="row">
                  {t(`month-${plan.announcementMonth}`)}
                </TableCell>
                <TableCell scope="row">
                  {plan.city}, {plan.deliveryAddress}
                </TableCell>
                <TableCell scope="row">
                  {plan.executionDurationInDays}
                </TableCell>
                <TableCell scope="row">Link</TableCell>
                {canEdit && (
                  <TableCell scope="row">
                    <div>
                      {onEdit && (
                        <IconButton onClick={() => onEdit(plan)}>
                          <Edit color="primary" fontSize="small" />
                        </IconButton>
                      )}
                      {onDelete && (
                        <IconButton onClick={() => onDelete(plan.id as string)}>
                          <Delete color="error" fontSize="small" />
                        </IconButton>
                      )}
                    </div>
                  </TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
        </StyledTable>
      </TableContainer>
    </Paper>
  )
}
